import { useRoutes, Navigate } from 'react-router-dom'
import { lazy, Suspense } from 'react'
import routes from './router/config'
import ScrollToTop from './components/ScrollToTop'
import ShopPage from './pages/shop/page'

const CMS = lazy(() => import('./cms/CMS'))

export function AppRoutes() {
  const mainRoutes = useRoutes([
    ...routes,
    // Category alias routes
    { path: '/kucni-brojevi', element: <ShopPage /> },
    { path: '/plocice-za-vrata', element: <ShopPage /> },
    { path: '/plocice-za-sanuce', element: <ShopPage /> },
    { path: '/znakovi', element: <ShopPage /> },
    { path: '/admin/*', element: (
        <Suspense fallback={<div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', height: '100vh', background: '#0f1117', color: '#fff', fontFamily: 'system-ui', fontSize: 14 }}>Loading CMS…</div>}>
          <CMS />
        </Suspense>
      ),
    },
  ])
  return (
    <>
      <ScrollToTop />
      {mainRoutes}
    </>
  )
}
